export const BHASHINI_SCRIPT =
    'https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js';
export const BHASHINI_LOGO_URL =
    'https://translation-plugin.bhashini.co.in/media-utilities/bhashini-logo.png';

export const BHASHINI_FEEDBACK_ICON_URL =
    'https://translation-plugin.bhashini.co.in/media-utilities/feedback.svg';